module.exports = __webpack_public_path__ + "static/media/Zone1LeftHipOverlay.eb842985.png";